declare global {
    interface Array<T> {
        getValueByKey(key: any, keyField?: string, valueField?: string): any;
        sum(fun: (x: T) => number): number

    }
}

Array.prototype.getValueByKey = function (key: any, keyField: string = 'key', valueField: string = 'value') {
    let obj = this.find((x: any) => x[keyField] === key);

    if (!obj)
        return key;

    return obj[valueField] ?? "";
};

Array.prototype.sum = function <T>(self: (a: T) => number) {

    let result = 0;
    this.forEach(x => result += self(x))
    return result
};

export { };